import * as React from "react";
import { Icon } from "./Icon";

export class GlobalMetaIcon extends Icon {

	render() {
		return <Icon {...this.props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
				<path d="M29.7,11.1l-8.8-8.8C20.6,2.1,20.4,2,20.1,2s-0.5,0.1-0.7,0.3l-9.6,9.6L7.5,9.5C7.1,9.1,6.4,9.1,6,9.5l-0.6,0.6c-0.4,0.4-0.4,1.1,0,1.5l3.1,3.1l3.4,3.4l-9.6,9.6c-0.4,0.4-0.4,1.1,0,1.5l0.6,0.6c0.4,0.4,1.1,0.4,1.5,0l9.6-9.6l3.4,3.4l3.1,3.1c0.4,0.4,1.1,0.4,1.5,0l0.6-0.6c0.4-0.4,0.4-1.1,0-1.5l-2.4-2.4l9.6-9.6C30.1,12.2,30.1,11.6,29.7,11.1z M18.7,20.7l-7.4-7.4l8.8-8.8l7.4,7.4L18.7,20.7z"/>
			</svg>
		</Icon>;
	}
}
